var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "caret-right_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#caret-right_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.875 17.125a.72.72 0 01-.225-.525c0-.2.075-.375.225-.525L12.95 12 8.875 7.925A.72.72 0 018.65 7.4c0-.2.075-.375.225-.525A.72.72 0 019.4 6.65c.2 0 .375.075.525.225l4.5 4.5a.826.826 0 01.188.287.944.944 0 010 .675.823.823 0 01-.188.288l-4.5 4.5a.72.72 0 01-.525.225.72.72 0 01-.525-.225z",
    fill: "#AAA"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/caret-right.87a554cf.svg";
export { SvgCaretRight as ReactComponent };